export class BillingAddress {
  id?: number;
  patientId: number;
  practiceId: number;
  address1: string;
  address2?: string;
  city: string;
  state: string;
  country: string;
  zipCode: string;
}

export class BillingAddressListReq {
  patientId: number = 0;
  practiceId: number = 0;
}

export class UpdateBillingAddress {
  billingAddressId: number;
  tokenId: number;
  patientId: number;
  practiceId: number;
  address1: string;
  address2?: string;
  city: string;
  state: string;
  country: string;
  zip: string;
  company?: string;
}
